<!--
exercise/exercise.vue
inscription/inscription.vue
-->

<template>
    <div class="s-datePicker">
<!--no-close-on-select = true-->
<!--:state="true" -->
<!--:state="_dateValue ? true : false"-->
        <b-form-datepicker 
            :id="name" 
            :state="_dateValue ? true : false"
            :label-no-date-selected="$t('dat_AucuneDateSelectionne')" 
            label-help=""
            :close-button = true
            close-button-variant = "outline-dark"
            label-close-button = "OK"
            label-today = "success"
            label-today-button = "aujourd'hui"
            :today-button = true
            today-button-variant = "outline-success"
            today-variant = "success"
            :no-close-on-select = true
            :min = "min"
            :max = "max"
            :disabled = "disabled"
            v-model="_dateValue">
        </b-form-datepicker>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: "s-datePicker",
    props:['dateValue', 'name', 'min', 'max', 'disabled'],
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _dateValue: {
            get: function() {return this.dateValue},
            set: function(modifiedValue){this.$emit('update:dateValue', modifiedValue)}
        },
    }
}

</script>

<style lang="scss" scoped>

</style>